import { useAuthContext } from "../hooks/useAuthContext"
import { useEffect, useState } from "react"
import { useBookingsContext } from "../hooks/useBookingsContext"

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import NewBooking from '../tabs/NewBooking'
import MyBookings from '../tabs/MyBookings'

import LaundryCalendar from '../components/LaundryCalendar'
import BalconyCalendar from '../components/BalconyCalendar'

import { strings } from '../strings'

import '../styling/tabs.css'

const Home = () => {

    const [error, setError] = useState(null)
    const { user, dispatch: logoutDispatch } = useAuthContext()
    const { dispatch } = useBookingsContext()

    useEffect(() => {

        const fetchBookings = async () => {
            setError(null)

            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/bookings', {
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            })
            const json = await response.json()

            if (!response.ok) {
                setError(json.msg)
                logoutDispatch({ type: 'LOGOUT' })
            }

            if (response.ok) {
                setError(null)

                const relevantBookings = json.filter((b) => { 
                    const start = new Date(b.start)
                    const bookingEnd = new Date(start)
                    bookingEnd.setHours(start.getHours() + b.duration)

                    return bookingEnd > new Date()
                })

                const historyBookings = json.filter((b) => { 
                    const start = new Date(b.start)
                    const bookingEnd = new Date(start)
                    bookingEnd.setHours(start.getHours() + b.duration)

                    return bookingEnd <= new Date()
                })

                dispatch({ type: 'SET_BOOKINGS', payload: relevantBookings })
                dispatch({ type: 'SET_HISTORY', payload: historyBookings })
            }
        }

        if (user) {
            fetchBookings()
        }

    }, [dispatch, user, logoutDispatch])

    const [chosen, setChosen] = useState(null)

    const handleClick = (page) => {
        setChosen(page)
    }

    return (
        <div className='home'>
            <Tabs onSelect={(tabIndex) => { if (tabIndex === 0) { setChosen(null) } }}>
                <TabList>
                    <Tab>{!chosen ? strings.home.chooseFacility : strings.home.newBooking }</Tab>
                    <Tab>{strings.home.myBookings}</Tab>
                </TabList>

                <TabPanel>
                    {!chosen && <NewBooking handleClick={handleClick}/>}
                    {(chosen && chosen === 1) && <LaundryCalendar facilityID={"Övre"} />}
                    {(chosen && chosen === 2) && <LaundryCalendar facilityID={"Nedre"} />}
                    {(chosen && chosen === 3) && <LaundryCalendar facilityID={"500"} />}
                    {(chosen && chosen === 4) && <BalconyCalendar facility={strings.balcony.balcony} />}

                </TabPanel>

                <TabPanel>
                    <MyBookings />
                </TabPanel>

            </Tabs>
            {error && <div className="error">{error}</div>}

        </div>
    )
}

export default Home
